import answerReducer from './';

export default answerReducer;
